import { useNavigate } from "react-router-dom";

import SanitisedHtml from "./SanitisedHtml";
import TailwaterLive from "./TailwaterLive";

import _ from 'lodash'

const LocationInfoBox = ({ setShowLocationInfoBox, entity, entities, category, categories }) => {

    const closeLocationInfoBox = () => {
        setShowLocationInfoBox(false)
    }

    const navigate = useNavigate();

    const goToBusinessDetails = (entity, category) => {
        navigate('/business-single', {state: {
            entity: entity,
            category: category,
        }})
    }

    const hasCategoryOrAncestor = (slugs) => {
        let currentCategory = category;
        while(currentCategory){
            if(_.includes(slugs, currentCategory.slug)) return true;
            currentCategory = _.find(categories, {id: currentCategory.parent});
        }
        return false;
    }

    const link = entity.meta.atf_website || entity.link;
    const details = <ul>
        { entity.atf_featured_image ?
         <li><img src={entity.atf_featured_image} alt=""/></li>
         : null }
        <li>
            <strong>Name:</strong>
            <span className="ml-1">
                {entity.title.rendered}
            </span>                
        </li>
        { category ?
        <li className="capitalize">
        <strong>Category:</strong> 
        <span className="ml-1">
            <SanitisedHtml html={category.name} as='span' />
        </span>
        </li>
        : null }
        {entity.meta.atf_phone ?
        <li>
            <strong>Phone:</strong> 
            <span className="ml-1">{entity.meta.atf_phone}</span>
        </li>
        :
        null }
         {entity.meta.atf_hours ?
            <li>
                <strong>Working hours:</strong>
                <span className="ml-1">{entity.meta.atf_hours}</span>
            </li> : null
        }

        {entity.excerpt ?
            <li>
                <strong>Details:</strong>
                <span className="ml-1">
                    <SanitisedHtml html={entity.excerpt.rendered} />
                </span>
            </li> : null
        }

        {hasCategoryOrAncestor(['fishing-spot']) && entity.tailwater_live ?
            <li><TailwaterLive entity={entity} /></li>
            : null
        }

        {entity.meta.atf_address ? 
            <li>
                <strong>Address:</strong>
                <span className="ml-1">{entity.meta.atf_address}</span>
            </li>
            : null
        }
        { 
        hasCategoryOrAncestor(['project', 'fishing-spot']) ?
        <li><br/>
            <a
                className="atf-location-details-btn"
                rel="noreferrer"
                target="_blank"
                href={link + "?utm_source=atf&utm_medium=web&utm_campaign=atf-" + entity.slug + "&utm_content=atf&utm_term=atf"}>Learn More</a>
        </li>
        :  <li><br/>
            <button
            className="atf-location-details-btn"
            rel="noreferrer"
            onClick={() => goToBusinessDetails(entity, category)}
            >Learn More</button>
        </li>
        }
    </ul>

    return (
        <div className="location-info">

            <div className="location-header-elements">
                <h2 className="location-info-header">Location Information</h2>
                <button className="infoCloseButton" onClick={closeLocationInfoBox}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M6 18L18 6M6 6l12 12"/>
                    </svg>
                </button>
            </div>

            {details}
        </div>
    )
}

export default LocationInfoBox
